export default __webpack_public_path__ + "static/media/inbox_nl.9e896782.png";